import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createPopup = async (data) => {
  try {
    let res = await Api.post("/popup", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const getPopupData = async (query) => {
  try {
    let res = await Api.get("/popup", { params: query });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deletePopupData = async (id) => {
  try {
    let res = await Api.delete("/popup/" + id);
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updatePopupData = async (id, data) => {
  try {
    let res = await Api.patch("/popup/" + id, data);
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const cleanupPopupImages = async (fileNames) => {
  if (!fileNames || fileNames.length === 0) return;
  try {
    await Api.post("/popup/cleanup-images", { fileNames });
  } catch (e) {
    // Best-effort cleanup — a failure here shouldn't block the save that already succeeded.
  }
};
